import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import supabase from "../../api/supabase"; // Ensure correct path to your Supabase instance
import useCurrentUser from "../user/useCurrentUser"; // Import the hook to manage user data
import "./LogOutButton.scss"; // Import your styling

const LogOutButton = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track user login status
  const navigate = useNavigate(); // Initialize navigate for redirecting
  const { clearUserProfile } = useCurrentUser(); // Get the function to clear user data

  // Check for active session on mount
  useEffect(() => {
    const checkSession = async () => {
      const { data, error } = await supabase.auth.getSession();

      if (error || !data.session) {
        setIsLoggedIn(false);
      } else {
        setIsLoggedIn(true);
      }
    };

    checkSession();
  }, []);

  const handleLogout = async () => {
    setIsLoggingOut(true);

    try {
      // Check for active session before logging out
      const { data, error: sessionError } = await supabase.auth.getSession();

      if (sessionError || !data.session) {
        console.log("No active session found. Already logged out.");
        clearUserProfile(); // Clear user data even if no session is found
        navigate("/login"); // Redirect to login page
        return;
      }

      // Proceed with Supabase sign out
      const { error } = await supabase.auth.signOut();

      if (error) {
        console.error("Error logging out:", error.message);
        setIsLoggingOut(false); // Reset logging out state if there’s an error
        return;
      }

      console.log("Logged out successfully");

      // Clear user profile data from both localStorage and state after successful logout
      clearUserProfile();

      // Redirect to login page after successful logout
      navigate("/login"); // Redirect to login page or any route you prefer
    } catch (err) {
      console.error("Unexpected error during logout:", err);
    } finally {
      setIsLoggingOut(false); // Ensure logging out state is reset
    }
  };

  if (!isLoggedIn) {
    return null; // Don't show the logout button if the user isn't logged in
  }

  return (
    <span
      className="logout-button"
      onClick={handleLogout}
      disabled={isLoggingOut} // Disable button while logging out
    >
      {isLoggingOut ? "Logging out..." : "Logout"}
    </span>
  );
};

export default LogOutButton;
